module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "logo-app"
  }), _vm._v(" "), _c('v-card', {
    staticClass: "login-form"
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Plataforma de Pagos\n          "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 5)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\n            Para poder registrar sus trámites debe ingresar su usuario y contraseña de la Plataforma de pagos de su entidad aquí.\n          ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "label": _vm.$t('login.user'),
      "id": "username",
      "append-icon": "person",
      "autofocus": "",
      "maxlength": "25",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": _vm.$t('login.password'),
      "id": "password",
      "append-icon": "lock",
      "append-icon": _vm.getIcon,
      "append-icon-cb": _vm.changeIcon,
      "type": _vm.hidePass ? 'password' : 'text',
      "maxlength": "100",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "large": "",
      "disabled": !_vm.valid || _vm.loading,
      "type": "submit"
    }
  }, [_c('v-icon', [_vm._v("verified_user")]), _vm._v(" " + _vm._s(_vm.$t('login.login')) + "\n          ")], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-548c8818","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eApostilla/documento/LoginPpte.vue
// module id = 519
// module chunks = 2